export const adapterModelCarsForMap = (cars, dtransport_id, route_and_type) => {
  // dtransport_id в объекте для того, чтобы на карте потом получить цвет. route_and_type для уникального значения маршрута
  return cars.map(i => {
    return { ...i, dtransport_id, route_and_type }
  })
}